import request from '@/utils/request'
export function queryFGs(params) {
  return request({
    url: '/api/masterdata/queryFGs',
    method: 'get',
    params,
  })
}
export function queryNetIds(params) {
  return request({
    url: '/api/masterdata/queryNetIds',
    method: 'get',
    params,
  })
}
export function querySourceRegionCodes(params) {
  return request({
    url: '/api/masterdata/querySourceRegionCodes',
    method: 'get',
    params,
  })
}
export function queryOpIds(params) {
  return request({
    url: '/api/masterdata/queryOpIds',
    method: 'get',
    params,
  })
}
export function queryMaterialGroupIds(params) {
  return request({
    url: '/api/masterdata/queryMaterialGroupIds',
    method: 'get',
    params,
  })
}
export function queryRegionCodes(params) {
  return request({
    url: '/api/masterdata/queryRegionCodes',
    method: 'get',
    params,
  })
}
export function getJobIds(data) {
  return request({
    url: '/api/masterdata/newBomByApplyFrom',
    method: 'post',
    data,
  })
}
export function queryWsBom(data) {
  return request({
    url: '/api/masterdata/queryWsBom',
    method: 'post',
    data,
  })
}
export function saveWsBoms(data) {
  return request({
    url: '/api/masterdata/saveWsBoms',
    method: 'post',
    data,
  })
}
export function updateWsBom(data) {
  return request({
    url: '/api/masterdata/updateWsBom',
    method: 'post',
    data,
  })
}
export function delWsBom(data) {
  return request({
    url: '/api/masterdata/delWsBom',
    method: 'post',
    data,
  })
}
export function delWsBoms(data) {
  return request({
    url: '/api/masterdata/delWsBoms',
    method: 'post',
    data,
  })
}
export function validateSave(data) {
  return request({
    url: '/api/masterdata/testByItemList',
    method: 'post',
    data,
  })
}
export function testByItem(data) {
  return request({
    url: '/api/masterdata/testByItem',
    method: 'post',
    data,
  })
}
